import Vue from "vue";
import Vuex from "vuex";
import { createHttpServer } from "@/api/axios";

Vue.use(Vuex);

const getModules = (group = [], result = {}) => {
  group.forEach(item => {
    let key = item.replace(/(^\.\/)|(\.js)/g, "");
    result[key] = file(item).default || file(item);
  });
  return result;
};
const file = require.context("./modules", false, /\.js$/);
const modules = getModules(file.keys());

export default new Vuex.Store({
  state: {
    http: createHttpServer("speedbiz"),
    http_op: createHttpServer("speedbiz-operation")
  },
  modules
});



// WEBPACK FOOTER //
// ./src/store/index.js